<template>
  <b-tab>
    <template v-slot:title>Reports</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Reports</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_reports == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_reports')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_reports')" />
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">Savings Reports</div>
          <div class="col-2">Performance Reports</div>
          <div class="col-2">Loan Reports</div>
          <div class="col-3">Other Reports</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- Savings Reports -->
          <div class="col-2">
            <RockerSwitch v-if="item.savings_report == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'savings_report')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'savings_report')" />
          </div>

          <!-- Performance Reports -->
          <div class="col-2">
            <RockerSwitch v-if="item.performance_reports == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'performance_reports')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'performance_reports')" />
          </div>

          <!-- Loans Reports -->
          <div class="col-2">
            <RockerSwitch v-if="item.loans_report == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'loans_report')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'loans_report')" />
          </div>

          <!-- Other Reports -->
          <div class="col-2">
            <RockerSwitch v-if="item.other_reports == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'other_reports')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'other_reports')" />
          </div>
        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "ReportPermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_reports == 1);
    },
  },

  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>